import { useSelectedChain } from "@app/examples/ChainSelector";
import { ConnectedWallet, useConnectedWallet, useWallet } from "@terra-money/wallet-provider";
import { Baaanggg, CredentialRequest } from "baaanggg";
import { useEffect, useState } from "react";
import useAlert, { AlertUtils } from "./AlertHook";

export function useBaaanggg() {
    const alert = useAlert()
    const apiUrl = "https://api.bigbangx.io";

    const client = new Baaanggg(apiUrl, {
        useLocalStorage: true,
        requestAuthCallback: async () => Promise.reject()
    })
    const [baaanggg, setBaaanggg] = useState<Baaanggg>(client)
    const myWallet = useConnectedWallet()
    const { disconnect } = useWallet()

    useEffect(() => {
        if (myWallet) {
            const client: Baaanggg = new Baaanggg(apiUrl, {
                useLocalStorage: true,
                requestAuthCallback: async () => await signIn(alert, myWallet, client, () => disconnect())
            })
            setBaaanggg(client)
        }
    }, [myWallet])

    return baaanggg
}

const signIn = async (alert: AlertUtils, wallet: ConnectedWallet, baaanggg: Baaanggg, onFailed: () => void) => {
    try {
        const walletAddress = wallet.terraAddress;

        const response = await baaanggg.user.isRegistered(walletAddress)
        if (!response.isRegistered) throw "Account not registered yet"

        const msg = {
            type: "/user/Authenticate",
            address: walletAddress
        }
        const msgJson = JSON.stringify(msg);

        alert.loading("Request auth signing, please check your wallet")
        const result = await wallet.signBytes(Buffer.from(msgJson));
        alert.hide()

        const signature = Buffer.from(result.result.signature).toString('base64');
        const publicKey = result.result.public_key!.toAmino().value.toString()

        const credential: CredentialRequest = {
            publicKey,
            signature,
            walletAddress
        }
        await baaanggg.auth.signIn(credential)
    } catch (e) {
        onFailed()
        alert.hide()
        throw e
    }
} 